import FilterBoxList from './FilterBoxList';

export default function IndustryFilter({
	industries,
	isInsidePopup = false,
	industriesSearchInput,
	setIndustriesSearchInput,
	filters,
	setFilters
}) {
	const filteredIndustries = industries?.filter(
		industry => industry?.industriesCustom?.hidden !== true
	);
	return (
		<>
			<div class={`relative block ${isInsidePopup ? 'mb-6' : 'mb-4'}`}>
				<input
					type="text"
					placeholder="Søk etter næring"
					class="appearance-none placeholder-muted text-base bg-light-gray border-2 border-light-gray rounded-md h-11 pl-3.5 pr-11 w-full hover:bg-gray hover:border-gray focus:outline-none focus:border-gray"
					onChange={e => setIndustriesSearchInput(e.target.value)}
					onKeyPress={e => {
						if (e.key === 'Enter') {
							setIndustriesSearchInput(industriesSearchInput);
						}
					}}
					value={industriesSearchInput}
				/>
				<button
					class="absolute top-0 right-0 px-4 h-full"
					onClick={() =>
						setIndustriesSearchInput(industriesSearchInput)
					}
				>
					<i class="far fa-search"></i>
				</button>
			</div>
			{isInsidePopup ? (
				<div class="flex-grow relative">
					<div class="absolute w-full h-full inset-0 overflow-y-scroll">
						<FilterBoxList
							items={filteredIndustries}
							isInsidePopup={true}
							filters={filters}
							setFilters={setFilters}
							filterKey="industryTerms"
						/>
					</div>
				</div>
			) : (
				<FilterBoxList
					items={filteredIndustries}
					showFewer={true}
					filters={filters}
					setFilters={setFilters}
					filterKey="industryTerms"
				/>
			)}
		</>
	);
}
